<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3">TCP/UDP 포트 목록</div>
        <div class="setting-addel mr-l15">
          <el-button @click="addServicePort"><i class="fas fa-plus"></i></el-button>
          <el-button :disabled="selectedRowArray.length === 0" @click="deleteServicePort"><i class="fas fa-minus"></i></el-button>
        </div>
      </div>
      <div>
        <el-button size="small" type="primary" @click="clickSaveButton" :disabled="!changeFlag">저장</el-button>
        <el-button size="small" @click="clickResetButton" :disabled="!changeFlag">취소</el-button>
        <w-header-search-button size="mini" @click="setSearchToolVisible"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper :column-default="columnDefault" @selection-change="changeHandleSelection"
      :data="portTableData" :columns="tableColumn" :show-search-tool="showSearchTool" ref="servicePortTable"
      style="width:100%;" :show-custom-header="true" :total="total" pagination remote @condition-change="onChangeTable">
      <template slot-scope="scope" slot="service-name">
        <el-input v-model="scope.row.serviceName" @change="onChangeServiceName(scope.row)" @keyup.enter.native="checkChangeFlag" />
      </template>
    </el-table-wrapper>
    <w-add-service-port-sliding-popup ref="addServicePortPopup" @load-data="loadData"></w-add-service-port-sliding-popup>
  </div>
</template>

<script>
import { differenceWith, isEqual, cloneDeep } from 'lodash';
import { isEmpty } from '@/utils/basic';
import msgUtil from '@/utils/message';
import { columnDefault } from '@/constants/table';
import OperationSettingsAPI from '@/api/settings/common/operation-settings';
import WAddServicePortSlidingPopup from './popup/AddServicePortSlidingPopup';

export default {
  name: 'WServicePort',
  components: { WAddServicePortSlidingPopup },
  data() {
    return {
      total: null,
      columnDefault,
      showSearchTool: false,
      portTableData: [],
      portTableOriginData: [],
      tableColumn: [
        {
          align: 'center',
          type: 'selection',
        },
        {
          prop: 'netPortnum',
          label: '포트',
          remoteProp: 'net_portnum',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'netProtocol',
          label: '프로토콜',
          remoteProp: 'net_protocol',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'serviceName',
          label: '서비스명',
          sortable: true,
          searchable: true,
          remoteProp: 'service_name',
          scopedSlot: 'service-name',
        },
      ],
      selectedRowArray: [],
      // currentPage: 1,
      changeFlag: false,
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.selectedRowArray = [];
      const tableParams = this.$refs.servicePortTable.getParameter();
      const params = {
        ...tableParams,
      };
      OperationSettingsAPI.getNetPortSvcName(params).then((response) => {
        if (response.data.success) {
          this.portTableData = response.data.data;
          this.portTableOriginData = cloneDeep(response.data.data);
          this.changeFlag = false;
          this.total = response.data.total;
          // this.$nextTick(() => {
          //   this.total = response.data.total;
          // });
        }
      });
    },
    setSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    onChangeTable() {
      this.loadData();
    },
    // 서비스 포트 추가
    addServicePort() {
      this.$refs.addServicePortPopup.open();
    },
    // 체크박스 선택한 대상 포트들 삭제
    deleteServicePort() {
      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE)).then(() => {
        OperationSettingsAPI.delNetPortSvcName(this.selectedRowArray).then((response) => {
          if (response.data.success) {
            this.loadData();
          }
          this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '포트', response.data.success));
        });
      });
    },
    // 테이블 체크박스 셀렉션 change함수
    changeHandleSelection(selectVal) {
      this.selectedRowArray = selectVal;
    },
    // 리셋(취소) 버튼 클릭
    clickResetButton() {
      this.portTableData = cloneDeep(this.portTableOriginData);
      this.checkChangeFlag();
    },
    // 저장버튼 클릭 - origin 데이터와 비교하여 달라진 대상을 배열로 반환한다.
    clickSaveButton() {
      const params = differenceWith(this.portTableData, this.portTableOriginData, isEqual);
      OperationSettingsAPI.setNetPortSvcName(params).then((response) => {
        if (response.data.success) {
          this.loadData();
        }
        this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, '포트', response.data.success));
      });
    },
    checkChangeFlag() {
      this.changeFlag = !isEqual(this.portTableData, this.portTableOriginData);
    },
    /**
     *  서비스 값이 빈값인 경우 null을 셋팅한다.
     * @param  {[type]} record [description]
     * @return {[type]}        [description]
     * @author jda
     */
    onChangeServiceName(record) {
      if (isEmpty(record.serviceName)) {
        delete record.serviceName;
      }
      this.checkChangeFlag();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/operation/BasicInfoSettings/DomainServicePort/ServicePort.vue